
// @ts-check


/**
 * @template T 
 * @param {T | null} a 
 * @return {T[]}
 * */
function liftSansNull(a) {
    return (a === null) ? [] : [a];
}



export { liftSansNull };